// extracted by mini-css-extract-plugin
export default {"wrapper":"WordCloudWraper_wrapper__inYgd","words":"WordCloudWraper_words__Mh6Ia"};